import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Form, Select, Button, message, Spin } from "antd";
import {
  Previousinsurer,
  insuranceproduct,
  quick_quotes_Bike,
} from "../../Redux/actions/NumBikeation";
import axiosInstance from "../../Redux/axios/AxiosInstance";

const { Option } = Select;

const PolicySteps4 = ({ vehicleDetails }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(Previousinsurer());
    dispatch(insuranceproduct())
      .then((res) => {
        if (res && Array.isArray(res)) {
          setProducts(res);
        } else {
          console.error("Unexpected response format:", res);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch insurance products", err);
      });
  }, [dispatch]);

  const auth = JSON.parse(localStorage.getItem("vibeReg")) || {};
  const isuser = JSON.parse(localStorage.getItem("vibeUser")) || {};
  const is_POSP = isuser?.isPOSP ? 1 : 0;
  const posp_id = isuser?.isPOSP ? isuser?.pospid : "";

  const onSubmit = async (values) => {
    try {
      setLoading(true);
      const post = {
        insuranceProductCode: values.product,
        policyHolderType: values.customertype,
        make: vehicleDetails?.make,
        model: vehicleDetails?.model,
        variant: vehicleDetails?.type,
        licensePlateNumber: auth?.commercial_vehicle_number,
        manufactureDate: values.registrationdate,
        registrationDate: values.registrationdate,
        isPreviousInsurerKnown: 0,
        previousInsurerCode: values.insurer,
        previousNoClaimBonus: "ZERO",
        pincode: "600004",
        isPOSP: 0,
        insurance_id: auth.commercial_insurance_id,
      };

      const res = await axiosInstance.post(
        "v1/commercial_vehicle/quickquotes",
        post
      );

      if (res.status === 200 && !res.data.error) {
        localStorage.setItem("quickquotes", JSON.stringify(res.data.data));
        dispatch(quick_quotes_Bike({ data: res.data.data, post }));
        history.push("/planlayoutbike");
      } else {
        message.error(res.data.error.validationMessages.join(", "));
      }
    } catch (error) {
      console.error("Quick Quotes API Error:", error);
      message.error("Something went wrong. Please try again!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Spin spinning={loading}>
      <Form form={form} layout="vertical" onFinish={onSubmit}>
        <Form.Item
          name="product"
          label="Product"
          rules={[{ required: true, message: "Please select a product" }]}
        >
          <Select placeholder="Select a product">
            {products.map((product) => (
              <Option key={product.id} value={product.code}>
                {product.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="customertype"
          label="Customer Type"
          rules={[{ required: true, message: "Please select customer type" }]}
        >
          <Select placeholder="Select customer type">
            <Option value="individual">Individual</Option>
            <Option value="company">Company</Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="insurer"
          label="Previous Insurer"
          rules={[
            { required: true, message: "Please select previous insurer" },
          ]}
        >
          <Select placeholder="Select previous insurer">
            {/* Replace with dynamic insurers list if available */}
            <Option value="insurer1">Insurer 1</Option>
            <Option value="insurer2">Insurer 2</Option>
          </Select>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Spin>
  );
};

export default PolicySteps4;
